import { getWidths, isTouch } from "./utils";

const PIXEL_RATIO = () => {
  const ctx = document.createElement("canvas").getContext("2d"),
    dpr = window.devicePixelRatio || 1,
    bsr =
      ctx.webkitBackingStorePixelRatio ||
      ctx.mozBackingStorePixelRatio ||
      ctx.msBackingStorePixelRatio ||
      ctx.oBackingStorePixelRatio ||
      ctx.backingStorePixelRatio ||
      1;
  return dpr / bsr;
};
export const ratio = { value: PIXEL_RATIO() };

export const msToTime = (s) => {
  const pad = (n, z) => {
    z = z || 2;
    return ("00" + n).slice(-z);
  };
  let ret = "";
  const ms = pad(s % 1000, 3);
  ret = ms + ret;
  s = (s - ms) / 1000;
  const secs = pad(s % 60);
  if (secs > 0) ret = secs + "." + ret;
  s = (s - secs) / 60;
  const mins = pad(s % 60);
  if (mins > 0) ret = mins + ":" + ret;
  const hrs = pad((s - mins) / 60);
  if (hrs > 0) ret = hrs + ":" + ret;
  if (secs === "00" && mins === "00" && hrs === "00" && ms !== "00") ret = "0." + ret;
  return ret;
};

export const applyBrightness = (color, percent) => {
  let hex = color.match(/^#?([0-9a-f]{3}|[0-9a-f]{6})$/i);
  if (hex !== null) {
    hex = hex[1];
    if (hex.length === 3) {
      hex = hex.replace(/(.)/g, "$1$1");
    }

    let R = parseInt(hex.substring(0, 2), 16);
    let G = parseInt(hex.substring(2, 4), 16);
    let B = parseInt(hex.substring(4, 6), 16);

    R = parseInt(R + percent);
    G = parseInt(G + percent);
    B = parseInt(B + percent);

    R = R < 0 ? 0 : R > 255 ? 255 : R;
    G = G < 0 ? 0 : G > 255 ? 255 : G;
    B = B < 0 ? 0 : B > 255 ? 255 : B;

    const RR = R.toString(16).length === 1 ? "0" + R.toString(16) : R.toString(16);
    const GG = G.toString(16).length === 1 ? "0" + G.toString(16) : G.toString(16);
    const BB = B.toString(16).length === 1 ? "0" + B.toString(16) : B.toString(16);
    return "#" + RR + GG + BB;
  }

  const rgb = color.match(/^(?:rgb\()(\d{1,3}),?\s*(\d{1,3}),?\s*(\d{1,3}),?\s*\)/);
  if (rgb !== null) {
    rgb[0] += 255 * (percent / 100);
    rgb[1] += 255 * (percent / 100);
    rgb[2] += 255 * (percent / 100);
    return `rgb(${rgb[0]} ${rgb[1]} ${rgb[2]})`;
  }

  console.error("is broken color - " + color);
};

export function onResize(...args) {
  ratio.value = PIXEL_RATIO();
  if (isTouch) {
    setTimeout(() => {
      for (const fun of arguments) fun();
      let viewport = document.querySelector("meta[name=viewport]");
      viewport.setAttribute("content", "width=device-width, initial-scale=1.0, maximum-scale=1.0");
    }, 600);
  } else for (const fun of arguments) fun();
}

export const getLineObj = (x1, y1, x2, y2) => {
  return { start: { x: x1, y: y1 }, end: { x: x2, y: y2 } };
};
export const lineSegmentPoint = (line, x) => {
  const ratio = (x - line.start.x) / (line.end.x - line.start.x);
  const resX = line.start.x + ratio * (line.end.x - line.start.x);
  const resY = line.start.y + ratio * (line.end.y - line.start.y);
  return { x: resX, y: resY };
};

export const createHiDPICanvas = (w, h, canv, useRatio = true) => {
  canv.width = useRatio ? w * ratio.value : w;
  canv.height = useRatio ? h * ratio.value : h;
  canv.style.width = w + "px";
  canv.style.height = h + "px";
  canv.getContext("2d").setTransform(useRatio ? ratio.value : 1, 0, 0, useRatio ? ratio.value : 1, 0, 0);
  return canv;
};
export const setBaseSize = (sizeObj) => {
  const s = getWidths();
  sizeObj.windowWidth = s.windowWidth;
  sizeObj.visibleWidth = s.visibleWidth;

  sizeObj.marginLeft = sizeObj.windowWidth > 1000 ? 15 : 0;
  sizeObj.marginRight = 1; //Чтобы не появлялась горизонтальная прокрутка

  sizeObj.widthWithDataBy = sizeObj.visibleWidth - sizeObj.marginLeft - sizeObj.marginRight;
  sizeObj.width = sizeObj.widthWithDataBy - (sizeObj.windowWidth > 1000 ? 50 : 0);
};

export const updSTATE = (timePassed, STATE) => {
  if (STATE.progress !== undefined) {
    STATE.progress = timePassed / STATE.animDuration;
    if (STATE.progress > 1) STATE.progress = 1;
  }
  for (const phase of STATE.phases) {
    const state = STATE[phase[0]];
    const method = phase[1];
    if (timePassed > state.animDuration) {
      method(state.animDuration);
      timePassed -= state.animDuration;
    } else {
      method(timePassed);
      timePassed = 0;
    }
  }
};
export const resetState = (STATE) => {
  STATE.timePassed = 0;
  updSTATE(STATE.timePassed, STATE);
};
export const setFullAnimDur = (STATE) => {
  let fullAnimDur = 0;
  for (const phase of STATE.phases) {
    fullAnimDur += STATE[phase[0]].animDuration;
  }
  STATE.animDuration = fullAnimDur;
};
const deselectDriver = (selectedDrivers, pos) => {
  for (let i = 0; i < selectedDrivers.length; i++) {
    if (selectedDrivers[i] === pos) selectedDrivers.splice(i, 1);
  }
};
export const clickOnMainCheckBox = (selectedDrivers, driversCount) => {
  if (selectedDrivers.length < driversCount) {
    selectedDrivers.length = 0;
    for (let i = 1; i <= driversCount; i++) selectedDrivers.push(i);
  } else selectedDrivers.length = 0;
};
export const clickOnDriver = (selectedDrivers, pos, forceRedraw = () => {}) => {
  if (selectedDrivers.includes(pos)) {
    deselectDriver(selectedDrivers, pos);
  } else selectedDrivers.push(pos);
  forceRedraw();
};

export const getRowsPattern = (rowHeight, bg = "#FFFFFF") => {
  const rect = document.createElement("canvas");
  rect.width = 10;
  rect.height = rowHeight * 2;
  const ctx = rect.getContext("2d");
  ctx.fillStyle = bg;
  ctx.fillRect(0, 0, 10, rowHeight * 2);
  ctx.fillStyle = applyBrightness(bg, -10);
  ctx.fillRect(0, rowHeight, 10, rowHeight);

  return rect;
};
export const getShadows = (w = 20) => {
  const getShadow = (isLeft) => {
    const shadow = document.createElement("canvas");
    shadow.width = w;
    shadow.height = 10;
    const ctx = shadow.getContext("2d");

    const gradient = ctx.createLinearGradient(0, 0, w, 0);
    gradient.addColorStop(isLeft ? 1 : 0, "rgba(0,0,0,0.2)");
    gradient.addColorStop(isLeft ? 0 : 1, "rgba(0,0,0,0)");
    ctx.fillStyle = gradient;
    ctx.fillRect(0, 0, w, 10);

    return shadow;
  };

  return { left: getShadow(true), right: getShadow(false) };
};
export const getGridPattern = (rectSize = 10, color = "#FFFFFF") => {
  const grid = document.createElement("canvas");
  grid.width = rectSize * 2;
  grid.height = rectSize * 2;

  const ctx = grid.getContext("2d");
  ctx.fillStyle = color;
  ctx.fillRect(0, 0, rectSize * 2, rectSize * 2);
  ctx.fillStyle = applyBrightness(color, -50); // -5000 percent wtf?
  ctx.fillRect(0, 0, rectSize, rectSize);
  ctx.fillRect(rectSize, rectSize, rectSize, rectSize);

  return grid;
};
export const setIncludedDriverAlpha = (selectedDrivers, driversCount, ctx, position, value = 0.4) => {
  if (selectedDrivers.length === 0) ctx.globalAlpha = value;
  else if (selectedDrivers.length < driversCount) {
    if (selectedDrivers.includes(position)) ctx.globalAlpha = 1;
    else ctx.globalAlpha = value;
  }
};
export const presentSettings = (ctx, position, xOffset, STATE, isStart = true) => {
  const [progress, curName] = isStart
    ? [STATE.driverPresent.progress, STATE.driverPresent.curName]
    : [STATE.finish.progress, STATE.finish.rightCol.curName];

  if (progress === 1) return 0;

  let resultXOffset = 0;
  if (curName < position - 1) {
    ctx.globalAlpha = 0;
    resultXOffset = xOffset;
  } else if (curName < position) {
    ctx.globalAlpha = 1 - (position - curName);
    resultXOffset = xOffset * (position - curName);
  }

  return resultXOffset;
};
export const changeSpeed = (isFaster, curSpeed, BURef, BDRef, step = 0.25, max = 3, min = -0.5) => {
  curSpeed += isFaster ? step : -step;
  curSpeed = Math.min(max, Math.max(min, curSpeed));

  BURef.current.disabled = curSpeed === max;
  BDRef.current.disabled = curSpeed === min;

  return curSpeed;
};

// Draw methods
export const drawTimeLine = (ctx, lineWidth, STATE, flag, options) => {
  const o = {
    timeLinePadding: 20,
    timeLineY: 20,
    BGColor: "#F00",
    color: "#FFF",
    showFlag: true,
    flagOffset: 0,
    showTL: true,
    mr: 12,
  };
  if (options !== undefined) {
    for (const field of Object.keys(options)) o[field] = options[field];
  }

  const x1 = o.timeLinePadding;
  const y = o.timeLineY;
  const x2 = x1 + lineWidth;

  ctx.strokeStyle = o.color;
  ctx.fillStyle = o.color;
  ctx.lineWidth = 2;

  ctx.beginPath();
  ctx.moveTo(x1, y);
  ctx.lineTo(x2, y);
  ctx.stroke();

  // traffic light
  if (o.showTL) {
    ctx.save();
    const tlr = 3;
    // const tlx = size.lColWidth + size.fieldWidth / 2 - tlr * 4
    const tlx =
      o.timeLinePadding +
      lineWidth * ((STATE.driverPresent.animDuration + STATE.trafficLight.animDuration) / STATE.animDuration) -
      tlr * 10;
    const tly = o.timeLineY - tlr;

    ctx.fillStyle = o.BGColor;
    ctx.fillRect(tlx - 2 * tlr, tly - tlr, 12 * tlr, 6 * tlr);

    ctx.fillStyle = "#000";
    ctx.strokeStyle = "#000";
    ctx.lineWidth = 0.5;
    for (let i = 0; i < 5; i++) {
      if (STATE.trafficLight.phase - 1 >= i) ctx.fillStyle = "#f00";
      if (STATE.trafficLight.phase >= 6) ctx.fillStyle = "#0f0";
      ctx.beginPath();
      ctx.arc(tlx + tlr * 2 * i, tly, tlr, 0, 2 * Math.PI);
      ctx.fill();
      ctx.stroke();

      ctx.beginPath();
      ctx.arc(tlx + tlr * 2 * i, tly + tlr * 2, tlr, 0, 2 * Math.PI);
      ctx.fill();
      ctx.stroke();

      ctx.fillStyle = "#000";
    }
    ctx.restore();
  }

  // flag
  if (o.showFlag) {
    const fw = 14;
    const fh = 16;
    const fad = STATE.finish ? STATE.finish.animDuration : 0;
    const fx = o.timeLinePadding + lineWidth * ((STATE.animDuration - fad) / STATE.animDuration) + o.flagOffset;
    ctx.fillStyle = o.BGColor;
    ctx.fillRect(fx - 3, y - 3, fw + 6, 6);
    ctx.drawImage(flag, fx, y - fh / 2, fw, fh);
  }

  // marker
  const progress = STATE.timePassed / STATE.animDuration;
  const mx = Math.round(x1 + (x2 - x1) * progress);
  ctx.fillStyle = o.color;
  ctx.beginPath();
  ctx.arc(mx, y, o.mr, 0, 2 * Math.PI);
  ctx.fill();
  ctx.fillStyle = o.BGColor;
  ctx.beginPath();
  ctx.arc(mx, y, o.mr - 2, 0, 2 * Math.PI);
  ctx.fill();
  ctx.fillStyle = o.color;
  ctx.beginPath();
  ctx.arc(mx, y, o.mr - 4, 0, 2 * Math.PI);
  ctx.fill();
};
export const drawCheckBox = (ctx, isChecked, x, y, size, xOffset = 0) => {
  if (isChecked) {
    ctx.beginPath();
    ctx.moveTo(x + 2 + xOffset, y);
    ctx.lineTo(x + size / 2.5 + xOffset, y + size / 2 - 3);
    ctx.lineTo(x + size - 2 + xOffset, y - size / 2 + 4);
    ctx.stroke();
  }
  ctx.beginPath();
  ctx.moveTo(x + xOffset, y - size / 2);
  ctx.lineTo(x + size + xOffset, y - size / 2);
  ctx.lineTo(x + size + xOffset, y + size - size / 2);
  ctx.lineTo(x + xOffset, y + size - size / 2);
  ctx.lineTo(x + xOffset, y - size / 2);
  ctx.stroke();
};
